export default function isEmpty(value) {
    if (!value)
        return true;
    for (const _ in value)
        return false;
    return true;
}
;
